import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Fabric, Pivot, PivotItem } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { useSelector } from 'react-redux';
import { lookupsLoadingFinishedSelector } from 'store/lookups/selector';
import { Helmet } from 'react-helmet';
import { AuftragsuebersichtView } from 'reports/auftragsuebersicht/AuftragsuebersichtView';
import { authSelector } from 'store/auth/selector';
import { BetreuerabrechnungView } from 'reports/betreuerabrechnung/BetreuerabrechnungView';
import { RechnungsuebersichtView } from 'reports/rechnungsuebersicht/RechnungsuebersichtView';
import { ReclayZahlungView } from 'reports/reclayzahlung/ReclayZahlungView';
import { ArtikelumsatzView } from 'reports/artikelumsatz/ArtikelumsatzView';
import { UmsatzuebersichtView } from 'reports/umsatzuebersicht/UmsatzuebersichtView';
import { RahmenauftraegeView } from 'reports/rahmenauftraege/RahmenauftraegeView';
import { ArbeitszeituebersichtView } from 'reports/arbeitszeituebersicht/ArbeitszeituebersichtView';
import { OffeneAuftraegeView } from 'reports/offeneauftraege/OffeneAuftraegeView';
import { ArtikeluebersichtView } from 'reports/artikeluebersicht/ArtikeluebersichtView';
import { AngebotsuebersichtView } from 'reports/angebotsuebersicht/AngebotsuebersichtView';
import { HochrechnungView } from 'reports/hochrechnung/HochrechnungView';

const styles = mergeStyleSets({
    container: {
        width: '100%',
        height: '100%',
    },
    itemWrapper: {
        height: 'calc(100vh - 75px)',
    },
});

const pivotStyles = {
    itemContainer: {
        height: 'calc(100vh - 120px)',
    },
};

interface ReportViewParams {
    page?: string;
}

export const ReportView: React.FC = () => {
    const auth = useSelector(authSelector);
    const lookupsLoadingFinished = useSelector(lookupsLoadingFinishedSelector);
    const history = useHistory();
    const { page } = useParams<ReportViewParams>();

    if (auth.rolle !== 'GF') {
        return null;
    }

    if (!page) {
        history.push('/berichte/auftragsuebersicht');
    }

    if (!lookupsLoadingFinished) {
        return null;
    }

    return (
        <Fabric className={styles.container}>
            <Helmet>
                <title>Berichte</title>
            </Helmet>
            <Pivot
                styles={pivotStyles}
                selectedKey={page || 'artikel'}
                onLinkClick={(item) => {
                    history.push('/berichte/' + (item?.props.itemKey || ''));
                }}
            >
                <PivotItem itemKey="angebotsuebersicht" headerText="Angebotsübersicht" className={styles.itemWrapper}>
                    <AngebotsuebersichtView />
                </PivotItem>
                <PivotItem itemKey="auftragsuebersicht" headerText="Auftragsübersicht" className={styles.itemWrapper}>
                    <AuftragsuebersichtView />
                </PivotItem>
                <PivotItem itemKey="rechnungsuebersicht" headerText="Rechnungsübersicht" className={styles.itemWrapper}>
                    <RechnungsuebersichtView />
                </PivotItem>
                <PivotItem itemKey="umsatzuebersicht" headerText="Umsatzübersicht" className={styles.itemWrapper}>
                    <UmsatzuebersichtView />
                </PivotItem>
                <PivotItem itemKey="hochrechnung" headerText="Hochrechnung" className={styles.itemWrapper}>
                    <HochrechnungView />
                </PivotItem>
                <PivotItem itemKey="artikeluebersicht" headerText="Artikelübersicht" className={styles.itemWrapper}>
                    <ArtikeluebersichtView />
                </PivotItem>
                <PivotItem itemKey="rahmenauftraege" headerText="Rahmenaufträge" className={styles.itemWrapper}>
                    <RahmenauftraegeView />
                </PivotItem>
                <PivotItem itemKey="offeneauftraege" headerText="Offene Aufträge" className={styles.itemWrapper}>
                    <OffeneAuftraegeView />
                </PivotItem>
                <PivotItem itemKey="betreuerabrechnung" headerText="Betreuerabrechnung" className={styles.itemWrapper}>
                    <BetreuerabrechnungView />
                </PivotItem>
                <PivotItem itemKey="artikelumsatz" headerText="Artikelumsatz" className={styles.itemWrapper}>
                    <ArtikelumsatzView />
                </PivotItem>
                <PivotItem itemKey="reclayzahlung" headerText="Reclay Zahlung" className={styles.itemWrapper}>
                    <ReclayZahlungView />
                </PivotItem>
                <PivotItem itemKey="arbeitszeituebersicht" headerText="Arbeitszeit" className={styles.itemWrapper}>
                    <ArbeitszeituebersichtView />
                </PivotItem>
            </Pivot>
        </Fabric>
    );
};
